import '../plugins/tabsPlugin';
import Vivus from '../plugins/vivusPlugin';


// content tabs init
export default function initTabs() {
	jQuery('.tabset').tabset({
		tabLinks: 'a',
		addToParent: true,
		onSwitched: function(self) {
			// If the tab that gets shown has any animated svg's (via vivus) inside it that also are using the AOS (animate on scroll) library, make sure they play as they wouldn't otherwise unless the user scrolls
			var $tab = $($(self.$tabLinks[self.activeTabIndex]).attr('href'));
			$tab.find('.animate-svg.aos-animate svg').each(function() {
				const vivus = new Vivus(this);
				vivus.play();
			})
			
		}
	});
	
}
